<template lang="pug">
v-container.px-10(fluid)
  v-progress-linear(
    :active="loading",
    indeterminate,
    color="primary",
    absolute,
    top
  )
  v-row.pb-10.pt-5.align-self-start(align="center", v-if="entity")
    v-col.py-0.text-right
      v-btn(color="white", @click="save()", :disabled="loading") {{ $t('Common.save') }}

  v-row(v-if="!loading")
    v-col.py-0
      v-card.elevation-24.mb-5
        app-full-entity(:entity="entity", :instance="instance", :selectorOnly="false", :selector="false", :ignoreTabs=`['status']`)
          template(v-slot:Bundle="props")
            general-bundle(v-model='instance', v-bind="{...props}")
          template(v-slot:shipments="props")
            app-entity-controller-multiple(v-model="instance.shipments", :entity=`$findEntity("Shipment")`, @added="setBundleKey")
          template(v-slot:orders="props")
            app-entity-controller-multiple(v-model="instance.orders", :entity=`$findEntity("Order")`, @added="setBundleKey")
          template(v-slot:orderLines="props")
            app-entity-controller-multiple(v-model="instance.orderLines", :entity=`$findEntity("OrderLine")`, @added="setBundleKey")

          

</template>

<script>
import axios from 'axios'
import AppEntity from '@@/components/entities/Entity.vue'
import GeneralBundle from '@/components/Bundle/General.vue'
export default {
  components: {
    GeneralBundle,
    AppEntity
  },
  name: 'bundle-add',
  data: () => ({
    loading: true,
    errors: {},
  }),
  computed: {
    instance: {
      get() {
        return this.$store.state.instance || {}
      },
      set(instance) {
        this.$store.commit('SET_INSTANCE', instance)
      }
    },
    entityName() {
      return 'Bundle'
    },
    entity() {
      return this.$searchEntity(this.entityName, 'name')
    },
    uid() {
      return this.$route.params.item
    },
    loads() {
      return [
        "ExtraData",
        "Shipments",
        "Orders",
        "OrderLines",
        "businessScope"
      ]
    }
  },
  methods: {
    setBundleKey(element) {
      element._updateKey = true;
    },
    setBundleKeys(elements) {
      elements.forEach(element => {
        if(element._updateKey){
          element.bundleKey = this.instance.key;
        }
        else if (element.entityState == 2){
          element.entityState = 3;
          element.bundleKey = "";
          element._hide = true;
        }
      })
    },
    /* TODO: docs */
    async save() {
      // this.loading = true
      const relations = {shipments:[],orders:[],orderLines:[]};
      try {
        // set "deleted" shipments bundle key as null and entity state 3 to track as modified
        if(this.instance.shipments != null)  {
          this.setBundleKeys(this.instance.shipments);
          relations.shipments.push(...this.instance.shipments);
        }
        if(this.instance.orders != null)  {
          this.setBundleKeys(this.instance.orders);
          relations.orders.push(...this.instance.orders);
        }
        if(this.instance.orderLines != null) {
          this.setBundleKeys(this.instance.orderLines);
          relations.orderLines.push(...this.instance.orderLines);
        }
        this.instance.shipments = null;
        this.instance.orders = null;
        this.instance.orderLines = null;
        this.instance = (await axios.post('entity/graph', { ...this.instance })).data
        await axios.post(`bundles/${this.instance.uid}/relations`, relations)
        this.$router.push({
          name: 'entities.index',
          params: { entity: this.entity.name }
        })
      } catch (error) {
        this.errors = error.response.data.errors
      }
      // this.loading = false
    },

    /* TODO: docs */
    async load() {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entityName}/${this.uid}`, true, ...this.loads)
          this.instance.uid = this.uid
          this.instance = {
            ...this.instance, ...(await axios.get(endpoint, {
              _Entity: this.entity.name,
              uid: this.uid
            })).data
          }
          this.instance.entityState = ENV.ENTITY.STATE.MODIFIED
          //this.instance.shipments.forEach(s => {s.entityState = 3;});
        } catch (error) {
          console.error(error)
        }
      } else
        this.$store.commit('SET_INSTANCE', { fields: [] })
      this.loading = false
    }
  },
  created() {
    this.$store.commit('SET_INSTANCE', null)
  },
  async mounted() {
    await this.load()
  }
}
</script>
